import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const PersuasionModalContext = /*#__PURE__*/createContext(null);
const PersuasionModalProvider = ({
  children
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {});
  const [onDecline, setOnDecline] = useState(() => () => {});
  return /*#__PURE__*/_jsx(PersuasionModalContext.Provider, {
    value: {
      isOpen,
      onConfirm,
      onDecline,
      setIsOpen,
      setOnConfirm,
      setOnDecline
    },
    children: children
  });
};
export const usePersuasionModal = () => {
  const context = useContext(PersuasionModalContext);
  if (!context) {
    throw new Error('usePersuasionModal must be used within a PersuasionModalProvider');
  }
  return context;
};
export default PersuasionModalProvider;
//# sourceMappingURL=PersuasionModalContext.js.map